import { createContext, useCallback, useContext, useMemo, useState } from "react";

const SentinelBusyCtx = createContext({ busyCount: 0, startBusy: () => () => {} });

export function SentinelBusyProvider({ children }) {
  const [busyCount, setBusyCount] = useState(0);

  const startBusy = useCallback(() => {
    setBusyCount((n) => n + 1);
    let done = false;
    return () => {
      if (done) return;
      done = true;
      setBusyCount((n) => Math.max(0, n - 1));
    };
  }, []);

  const value = useMemo(() => ({ busyCount, startBusy }), [busyCount, startBusy]);
  return <SentinelBusyCtx.Provider value={value}>{children}</SentinelBusyCtx.Provider>;
}

export const useSentinelBusy = () => useContext(SentinelBusyCtx);
